// =============================================================================
// src/rules/legal-targets.js  —  shared "what can be targeted" (Spot/GetTargets)
// -----------------------------------------------------------------------------
// SHARED RULES (client + server) — see src/rules/random.js for usage/bundling.
// Part of the anti-cheat surface. Self-contained (GetTargets calls Spot +
// GetLaneTargets in this same file).
//
// Strict-mode notes (old non-strict globals fixed for ESM):
//   - `temp` is now a real local variable.
//   - `selection` is a CLIENT-side UI global; writing it via `globalThis`
//     preserves that browser side effect and is safe (a harmless no-read) on the
//     server, where strict mode would otherwise throw on a bare assignment.
// =============================================================================

/**
 * Return the "Board_y_x" code for a card object on the board.
 * @param {object} duel
 * @param {object} Entry  card object
 * @returns {string|undefined}
 */
export function Spot(duel, Entry) {
	for (var i = 0; i < 4; i++) {
		for (var o = 0; o < 4; o++) {
			if (Entry == duel.board[i][o]) {
				console.log("Spot: " + "Board_" + i + "_" + o);
				return "Board_" + i + "_" + o;
			}
		}
	}
}

/**
 * Every legal target for a given source: spot-code -> boolean.
 * @param {object} duel
 * @param {string|object} Entry  "Card_i"/"Board_y_x"/"Devour"/card object.
 * @param {{ignoreFirstTurn?: boolean}} [opts]  ignoreFirstTurn skips the opening-
 *   turn opponent-face block. The SERVER never passes it (the rule always
 *   applies there); the client uses it to tell "this source could have hit the
 *   opponent, but the first-turn rule stopped it" from "it never could".
 * @returns {Object<string,boolean>}
 */
export function GetTargets(duel, Entry, opts = {}) {
	console.log("Get Targets for " + Entry);
	if (!Entry) {
		console.warn("🛑 Missing Entry passed to Get Targets:", Entry);
		console.trace("🛑 Get Targets call stack (Entry was falsy)");
		return;
	}
	var temp = {};
	if (typeof Entry === "string" && Entry.includes("Card_") && !Entry.includes("Devour_")) {
		Entry = duel.player1.hand[Number(Entry.split("_")[1])];
	}
	if (Entry == "Devour") {
		var maxI = 3;
		if (duel.player1.hero == 1) {//Luckfoot, Garden Raider
			maxI = 1;
		}
		for (var i = 0; i <= maxI; i++) {
			for (var o = 0; o < 4; o++) {
				temp["Board_" + i + "_" + o] = false;
				if (duel.board[i][o] != false) {
					if (i >= 2 || duel.board[i][o].health <= 0) {
						temp["Board_" + i + "_" + o] = true;
					}
				}
			}
		}
		temp["Opponent"] = false;
		if (duel.player2.deck == 0) {
			temp["Opponent"] = true;
		}
	} else if (Entry.event) {
		if (Entry.triggers.play) {
			temp["Yourself"] = true;
		} else if (Entry.triggers.opponent) {
			temp["Opponent"] = true;
		} else if (Entry.triggers.ally) {
			for (var i = 2; i < 4; i++) {
				for (var o = 0; o < 4; o++) {
					if (duel.board[i][o] != false) {
						temp["Board_" + i + "_" + o] = true;
					}
				}
			}
		} else if (Entry.triggers.threat) {
			for (var i = 0; i < 2; i++) {
				for (var o = 0; o < 4; o++) {
					if (duel.board[i][o] != false) {
						temp["Board_" + i + "_" + o] = true;
					}
				}
			}
		} else if (Entry.triggers.friend) {
			for (var i = 2; i < 4; i++) {
				for (var o = 0; o < 4; o++) {
					if (duel.board[i][o] != false) {
						if (Entry.triggers.friend === "Unique") {
							if ([69, 70].includes(Entry.id) && duel.board[i][o].name == "Egg") {//Egg
								temp["Board_" + i + "_" + o] = true;
							} else if ([11].includes(Entry.id)) {//Any
								temp["Board_" + i + "_" + o] = true;
							}
						} else {
							temp["Board_" + i + "_" + o] = true;
						}
					}
				}
			}
		} else if (Entry.triggers.target || Entry.triggers.any) {
			if (Entry.triggers.any) {
				temp["Yourself"] = true;
				temp["Opponent"] = true;
			}
			for (var i = 0; i < 4; i++) {
				for (var o = 0; o < 4; o++) {
					if (duel.board[i][o] != false) {
						if (Entry.id == 70 && duel.board[i][o].name != "Egg") {//Sit On The Egg
							continue;
						}
						if (Entry.id == 40 && duel.board[i][o].attack > 4) {//Get In My Belly
							continue;
						}
						if (Entry.id == 104) {//Full Moon
							if (!duel.board
								.slice(-2)
								.some((row) => row.some((item) => item?.tags?.includes("Canine")))) {
								continue;
							}
							if (duel.board[i][o].tags.includes("Canine")) {
								continue;
							}
						}
						temp["Board_" + i + "_" + o] = true;
					}
				}
			}
		}
	} else if (Entry.creature && !Entry.alive) {
		console.log("Get Open Spaces");
		for (var i = 2; i < 4; i++) {
			for (var o = 0; o < 4; o++) {
				if (duel.board[i][o] == false) {
					temp["Board_" + i + "_" + o] = true;
				}
			}
		}
	} else if ((typeof Entry === 'string' && Entry.includes("Board")) || (Entry.creature && Entry.alive)) {
		duel.temp = temp;
		var card = false;
		if (typeof Entry === 'string') {
			Entry = Entry.split("_");
			card = duel.board[Number(Entry[1])][Number(Entry[2])];
		} else {
			card = Entry;
			Entry = Spot(duel, card).split("_");
		}
		if (!card) {
			return temp;
		}
		if (card.owner != duel.player1.id) {
			globalThis.selection = false;
			return temp;
		}
		if (card.health <= 0 || card.keywords.guardian) {
			globalThis.selection = false;
			return temp;
		}
		GetLaneTargets(duel, card, Number(Entry[2]));
		if (card.keywords.flanker === true) {
			GetLaneTargets(duel, card, Number(Entry[2]) + 1);
			GetLaneTargets(duel, card, Number(Entry[2]) - 1);
		}
	}
	// FIRST-TURN RULE: the player who goes first may not attack or target the
	// opponent DIRECTLY on their opening turn — only the enemy LEADER
	// ("Opponent") is off-limits. Their creatures stay fair game, so this strips
	// just the face. GetTargets is the shared anti-cheat gate, so this enforces
	// the rule on the server AND hides the target in the client. The second
	// player and every later turn are unaffected.
	if (!opts.ignoreFirstTurn && isFirstPlayerOpeningTurn(duel)) {
		delete temp.Opponent;
	}
	return temp;
}

/**
 * Is the CURRENT actor the player who went first, on their very first turn?
 * (The board flip makes the actor player1; firstPlayerId is stable, so this is
 * true only during the opening turn of the game.)
 * @param {object} duel
 * @returns {boolean}
 */
export function isFirstPlayerOpeningTurn(duel) {
	return !!duel && duel.firstPlayerId != null
		&& duel.player1 && duel.player1.id === duel.firstPlayerId
		&& duel.player1.turn === 1;
}

/**
 * Mark legal attack targets down one lane (blockers, fliers, then opponent).
 * Writes into duel.temp (set up by GetTargets).
 * @param {object} duel
 * @param {object} card  attacker (checked for flier)
 * @param {number} lane  column 0–3
 */
export function GetLaneTargets(duel, card, lane) {
	console.log("Get Lane Targets:" + lane);
	if (lane < 0 || lane > 3) {
		console.log("Bad Lane");
		return;
	}
	if (duel.board[1][lane]) {
		duel.temp["Board_1_" + lane] = true;
	}
	if (duel.board[1][lane] == false || card.keywords.flier || duel.board[1][lane].health <= 0) {
		if (duel.board[0][lane]) {
			duel.temp["Board_0_" + lane] = true;
		}
		if (duel.board[0][lane] == false || duel.board[0][lane].health <= 0 || card.keywords.flier) {
			duel.temp["Opponent"] = true;
		}
	}
}
